export const SHOW_EDITOR_ERROR_MODAL = "UI/EDITOR_ERROR_MODAL/SHOW";
export const HIDE_EDITOR_ERROR_MODAL = "UI/EDITOR_ERROR_MODAL/HIDE";
